'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const RulerIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.4 12.4L9.90005 9.90001M6.30005 13.4L8.40005 15.5M13.4 6.30001L15.5 8.40001M20 8.30001L8.30005 19.9C7.90005 20.3 7.30005 20.3 6.90005 19.9L4.10005 17.1C3.70005 16.7 3.70005 16.1 4.10005 15.7L15.7 4.00001C16.1 3.60001 16.7 3.60001 17.1 4.00001L20 6.90001C20.4 7.20001 20.4 7.90001 20 8.30001Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpRulerIcon = forwardRef(RulerIcon);

export { VpRulerIcon as default };
